import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Weeklydrivehome = ({token}) => {

    const navigate = useNavigate();
         const handleNavigate = () => {
       const path = token ? `/driver-form?allow=${token}` : '/driver-form';
       navigate(path);
     };
  return (
<div
  onClick={() => navigate(`/merge-dashboard?type=weekly`)}
  className="mt-10 bg-white shadow-lg cursor-pointer rounded p-4 px-6 border-[1.5px] border-gray-100 
  flex flex-col justify-between
  transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:border-black"
>
  {/* Title */}
  <div className="text-[13px] font-semibold text-left">
    WEEKLY DRIVER LOG & SAFETY
  </div>

  {/* Helper text so user knows it's clickable */}
  <div className="text-xs text-gray-500 mt-1 flex items-center gap-1">
   Click here to generate reports
    <span className="text-sm">→</span>
  </div>

  {/* Bottom button */}
  <div className="flex justify-center mt-6">
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleNavigate();
      }}
      className="bg-black text-sm text-white px-6 py-1 w-full rounded flex items-center justify-center gap-2 transition hover:bg-gray-900"
    >
      <FiFileText className="text-md" />
      Fill out Form
    </button>
  </div>
</div>

  );
};

export default Weeklydrivehome;


